// extracted by mini-css-extract-plugin
module.exports = {"ContactNow":"ContactNow_ContactNow__3Abgw","DealerName":"ContactNow_DealerName__JvjZ3","DealerPhone":"ContactNow_DealerPhone__30GtM","ContactFrom":"ContactNow_ContactFrom__1aS-5"};